export const componentsEn = {
  headerNabvar: {
    es: {
      alt: 'Español',
      url: 'es.svg'
    },
    en:  {
      alt: 'English',
      url: 'gb.svg'
    }
  },
  fantasyNavbar: [
    {
      title: 'Dashboard',
      link: '/home',
      icon: 'mdi-view-dashboard'
    },
    {
      title: 'Fantasy',
      link: '/fantasy',
      icon: 'mdi-trophy',
      children: [
       /* {
          title: 'Home',
          link: '/fantasy/home',
          icon: 'mdi-home',
        },*/
        {
          title: 'Competitions',
          link: '/fantasy/competitions',
          icon: 'mdi-soccer-field',
        },
        {
          title: 'Matchsets',
          link: '/fantasy/matchsets',
          icon: 'mdi-calendar',
        },
        {
          title: 'Matches',
          link: '/fantasy/matches',
          icon: 'mdi-whistle',
        },
        {
          title: 'Teams',
          link: '/fantasy/teams',
          icon: 'mdi-account-group-outline',
        },
        {
          title: 'Players',
          link: '/fantasy/players',
          icon: 'mdi-account-details-outline',
        },
        {
          title: 'Contests',
          link: '/fantasy/contests',
          icon: 'mdi-crown',
        },
        {
          title: 'Networks',
          link: '/fantasy/networks',
          icon: 'mdi-lan',
        },
        {
          title: 'Categories',
          link: '/fantasy/categories',
          icon: 'mdi-table-large',
        },
      ]
    },
    {
      title: 'Casino',
      link: '/casino',
      icon: 'mdi-trophy',
      children: [
        /* {
           title: 'Home',
           link: '/fantasy/home',
           icon: 'mdi-home',
         },*/
        {
          title: 'RTP',
          link: '/casino/rtp',
          icon: 'mdi-soccer-field',
        },
        {
          title: 'Rounds',
          link: '/casino/rounds',
          icon: 'mdi-calendar-star'
        },
        {
          title: 'Lobby',
          link: '/casino/lobby',
          icon: 'mdi-file-tree'
        },
      ]
    },
    {
      title: 'Campaigs',
      link: '/campaigns',
      icon: 'mdi-diamond-stone',
      children: [
        {
          title: 'Freespins',
          link: '/campaigns/freespins',
          icon: 'mdi-gift-outline'
        },
        {
          title: 'FreeRounds',
          link: '/campaigns/freerounds',
          icon: 'mdi-decagram-outline'
        },
        {
          title: 'Opt-in',
          link: '/campaigns/optin',
          icon: 'mdi-check-decagram'
        },
        {
          title: 'Refer a friend',
          link: '/campaigns/referafriend',
          icon: 'mdi-account-multiple-plus'
        },
      ]
    },
    {
      title: 'Administrators',
      link: '/administrators',
      icon: 'mdi-account-star-outline'
    },
    {
      title: 'Users',
      link: '/users',
      icon: 'mdi-account-box-multiple'
    },
    {
      title: 'Games',
      link: '/games',
      icon: 'mdi-gamepad'
    },
    {
      title: 'Providers',
      link: '/providers',
      icon: 'mdi-google-controller',
    },
    {
      title:'Operators',
      link: '/operators',
      icon: 'mdi-poker-chip',
    },
    {
      title:'Finances',
      link: '/finances',
      icon: 'mdi-finance',
    },
    // {
    //   title:'Tournaments',
    //   link: '/tournaments',
    //   icon: 'mdi-tournament'
    // }
  ],
  token: {
    title: 'Warning: Session expire',
    text: 'The session is about to expire. It will close automatically in a few seconds.',
    button: {
      refresh: 'Refresh',
    },
  },
  basePasswordField: {
    repeatpassword: 'Password mismatch',
  },
  loginCard: {
    username: {
      label: 'Username',
      name: 'username',
      icon: 'mdi-account'
    },
    password: {
      label: 'Password',
      name: 'password',
      icon: 'mdi-lock'
    },
    pin: {
      label: 'Pin',
      name: 'pin',
      icon: 'mdi-email-lock'
    },
    infoPin: 'We send you th pin by email. Please, check your email.',
    submitUserText: 'Get Access',
    submitPinText: 'Login'
  },
  playerCompetitionInfoDialog: {
    buttonText: 'See stats',
    title: 'Points and values: ',
    table: {
      competition: 'Competition',
      team: 'Team',
      points: 'Points',
      value: 'Value',
    }
  },
  providerInfoDialog: {
    title: 'Provider\'s info',
  },
  operatorProvidersInfoDialog: {
    notFound: 'This operator have not providers',
    tablehead: {
      provider: 'Provider',
    },
    label: {
      ggr: 'GGR',
      invoice: {
        name: 'Name',
        address: 'Address',
        vat: 'VAT number',
        tax: 'Tax',
        phone: 'Phone',
        email: 'Email',
      },
    },
  },
  gamesInfoDialog:{
    name: 'Nombre',
    alias: 'Alias',
    type:'Tipo',
    jurisdictions:'Jurisdicciones',
    providers:'Proveedor',
    key:'Launch ID',
    button:'Ver Info'
  },
  MatchsetInfoDialog: {
    headers: {
      tabs: {
        players: 'Players',
        matches: 'Matches',
      },
      playersTable: {
        name: 'Name',
        team: 'Team',
        role: 'Position',
        value: 'Value',
      },
      matchesTable: {
        date: 'Date',
        teamhome: 'Local Team',
        score: 'Score',
        teamaway: 'Away Team',
        state: 'State',
      },
    },
  },
  roundInfoDialog:{
    title: 'Round info',
    roundId: 'Round ID',
    operator: 'Operator',
    provider: 'Provider',
    game: 'Game',
    moneyIn: 'Money in',
    moneyOut: 'Money out',
    user: 'User',
    status: 'Status',
    start: 'Start'
  },
  transactionInfoDialog:{
    title: 'Transactions',
    status: 'Status',
    created: 'Created',
    externalReference: 'External Reference',
    type:'Type',
    amount:'Amount',
    bonusAmount:'Bonus Amount',
    empty: 'There isn\'t Transactions'
  },
  ChangePasswordDialog: {
    title: 'Change password',
    label: {
      oldpassword: 'Current password',
      password: 'New password',
      repeatpassword: 'Repeat new password',
    },
    button: 'Change',
  },
  balanceCard:{
    noResults:'No results found',
  },
  pagination: {
    text: 'Rows per page:',
  },
  categoryInfoCard: {
    title: 'Information:',
    empty: 'This category haven\'t levels asociated',
    name: 'Name',
    level: 'Level',
    points: 'Points',
    rollDown: 'Roll Down',
    percentage: 'Percentage',
    button: 'See Info'
  },
  baseDynamicField: {
    button: {
      remove: 'Remove',
      add: 'Add',
    },
    label: {
      key: 'New key',
      value: 'New value'
    },
    advise: 'Not forget, the field is generated after push add button',
    dialog: {
      title: 'Advertisement',
      textempty: 'Must add a key',
      textrepeat: 'This field is repeated',
      button: 'Accept',
    },
  },
  baseDynamicLevel: {
    button: {
      remove: 'Remove',
      add: 'Add',
    },
    dialog: {
      title: 'Advertisement',
      advise: {
        points: 'Each new points field must be lower than previus level',
        percentage: 'All the percentages values must add up 100%',
      },
      button: 'Accept',
    },
  },
  baseFieldsGenerator: {
    resume: 'Resume:',
    newfield: 'New Field:',
    add: 'Add',
  },
  baseInvoiceItemsField: {
    button: {
      remove: 'Remove',
      add: 'Add',
    },
    label: {
      no: 'No.',
      description: 'Description',
      qty: 'Qty',
      price: 'Price',
      discount: 'Discount %',
      tax: 'Tax %',
      total: 'Total',
    },
    dialog: {
      title: 'Advertisement',
      text: 'Must add a description, a quantity and a price',
      button: 'Accept',
    },
  },
  operatorProviderEditDialog:{
    label: {
      key1: 'Key',
      key2: 'Secondary Key',
      key3: 'Terciary Key',
      launcher: 'Launcher',
      api: 'API',
      ggr: 'ggr',
      cap: 'Bonus cap',
      extrafields: 'Extra fields',
    },
    button:{
      edit: 'Edit',
    },
  },
};
